$bog_blitz_lobby_players $mol_list
	players_dict null
	my_lord_str \
	rows <= player_views /
	Player* $mol_row
		attr *
			bog_blitz_mine <= is_mine* false
		sub /
			<= player_avatar_content* null
			<= Player_id* $mol_paragraph
				title <= player_id* \
			<= player_name_content* null
	Player_icon* $mol_avatar
		id <= player_id* \
	Player_image* $mol_image
		uri <= player_avatar_uri* \
	Player_name_input* $mol_string_button
		hint @ \Touch to change
		value? <=> player_name*? \
	Player_name_label* $mol_paragraph
		title <= player_name* \
	Player_avatar_button* $mol_button_open
		sub /
			<= player_avatar* null
			<= Player_avatar_native* $mol_button_open_native
				files? <=> player_avatar_files*? /File
				accept \image/*
				multiple false
